import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ArticleIcon from "@mui/icons-material/Article";
import { Button, Box } from "@mui/material";
// import Blur from "../../assets/blur.svg";
// import nBlur from "../../assets/nblur.svg";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ApiHelper from "../../utillity/ApiHelper";
import APIURLConstants from "../../config/config";
import { useSiteState } from "../../hookState/SiteState";
import { makeStyles } from "@mui/styles";
import Snackbars from "../Snackbar/Snackbar";
import Helper from "../../utillity/helper";
import { useCartState, setCartState } from "../../hookState/CartState";
import RouteConstants from "../../constants/RouteConstant";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
const useStyles = makeStyles({
	cartBtn: {
		boxShadow: "none",
		"&:hover": {
			backgroundColor: "#FFAC1C",
			boxShadow: "0px 2px 12px #FFAC1C",
		},
	},
	buyBtn: {
		boxShadow: "none",
		// "&:hover": {
		// 	backgroundColor: "#b32419d1",
		// 	boxShadow: "0px 2px 12px #b32419d1",
		// },
	},
});
export default function MobileProductCard(props) {
	const state = useSiteState();

	const classes = useStyles();
	const cartState = useCartState();
	const [cartAdded, setCartAdded] = React.useState(0);
	const [snackBarProps, setSnackBarProps] = React.useState({
		openSnack: false,
		variant: "error",
		message: "",
	});
	// const { price_symbol, annualPrice, asin } = props.data;
	// console.log("data", props.data.price_symbol);

	const checkProductExist = (p_asin) => {
		if (p_asin && props.cartAdded && props.cartAdded.length > 0) {
			const cartStatus = props.cartAdded.find((key) => key.asin === p_asin)
				.cart_status_id;
			setCartAdded(cartStatus);
		}
		return;
	};
	const navigate = useNavigate();
	const addToCart = (productData) => {
		console.log("cartState", cartState);
		if (state.user.get() !== "") {
			const productInfo = {
				asin: productData.asin,
				user_id: state.user.id.get(),
			};

			props.addCartItem(productInfo);
		} else {
			props.addItem(productData);
		}
	};

	const redirectPageInfo = (productData) => {
		navigate(RouteConstants.PRODUCTINFO, {
			state: { product: productData },
		});
	};
	const handlePayment = (price, data) => {
		let cartData = [];
		cartData.push(data);
		navigate(RouteConstants.PAYMENT_GATEWAY, {
			state: { amount: price, cart: cartData, type: "unlimited" },
		});
	};
	const removeCard = (product_asin) => {
		props.removeProduct(product_asin);
	};

	return (
		<Box sx={{ zIndex: 999 }}>
			<Card
				sx={{
					display: "flex",
					// width: "376px",
					width: { xs: "190px", md: props.width ? props.width : "345px" },
					height: { xs: "105px", md: "198px" },
					borderRadius: "12px",
					// border: "1px solid #0072B1",
					// boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.25)",
					// boxShadow: " 0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23)",
					// margin: { xs: "auto", md: "0" },
					border: 1,
					borderColor: "#EEF2F6",
				}}
			>
				<CardContent
					sx={{
						width: { xs: "120px", md: "190px" },
						height: { xs: "100px", md: "170px" },
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-between",
						// p: 2,
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							p: { xs: 1, md: 3 },
						}}
					>
						<Typography
							fontSize={{ xs: 14, md: 18 }}
							fontWeight={600}
							color={"#191D23"}
						>
							{/* ${Math.floor(Math.random() * 100000) + 1} */}
							{props.data &&
								props.data.price_symbol &&
								props.data.price_symbol + " "}{" "}
							{props.data &&
								props.data.annualPrice &&
								Helper.numberFormat(
									typeof props.data.annualPrice === "string"
										? Number(props.data.annualPrice.replace(/\,/g, ""))
										: props.data.annualPrice
								)}
						</Typography>
						<Typography
							color="#667085"
							fontSize={{ xs: 14, md: 18 }}
							fontWeight={400}
							sx={{ textShadow: "0px 0px #667085" }}
						>
							Product income
						</Typography>
					</Box>
					<Box sx={{ display: "flex", flexDirection: "row" }}>
						{props.myAccount === true ? (
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-around",
									paddingLeft: 1,
								}}
							>
								<Button
									variant="contained"
									sx={{
										backgroundColor: "tertiary.main",
										color: "primary.main",
										borderRadius: "4px",
										height: "34px",
										width: "160px",
										textTransform: "capitalize",
										marginLeft: "14px",
										fontSize: { xs: "10px", md: "12px" },
										fontWeight: { xs: 500, md: 600 },
									}}
									onClick={() => {
										redirectPageInfo(props.data);
									}}
								>
									<ArticleIcon sx={{ fontSize: 20, mx: 1 }} />
									See Report
								</Button>
							</Box>
						) : (
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									ml: { xs: 1, md: 2 },
								}}
							>
								{state.user.get() !== "" &&
								state.plan.get() !== "" &&
								state.plan.get() !== undefined &&
								state.plan.get() !== null ? (
									<Button
										className={classes.cartBtn}
										variant="contained"
										sx={{
											backgroundColor: "tertiary.main",
											color: "primary.main",
											height: "34px",
											width: { xs: "100px", md: "134px" },
											textTransform: "capitalize",
											zIndex: 9999,

											borderRadius: 8,
											fontSize: { xs: "10px", md: "12px" },
											fontWeight: { xs: 500, md: 600 },
										}}
										onClick={() => addToCart(props.data)}
									>
										{"Add to Account"}
									</Button>
								) : null}

								{state.user.get() !== "" &&
								state.plan.get() !== "" &&
								state.plan.get() !== null &&
								state.plan.get() !== undefined ? null : (
									<Button
										variant="contained"
										sx={{
											backgroundColor: "tertiary.main",
											color: "primary.main",
											height: "28px",
											width: { xs: "110px", md: "134px" },
											textTransform: "capitalize",
											zIndex: 9999,

											borderRadius: 8,
											fontSize: { xs: "10px", md: "12px" },
											fontWeight: { xs: 400, md: 600 },
										}}
										onClick={() => {
											handlePayment(1, props.data);
										}}
									>
										Click to Access
									</Button>
								)}
							</Box>
						)}
					</Box>
				</CardContent>

				<Box
					sx={{
						height: "100%",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						alignContent: "center",
					}}
				>
					<CardMedia
						component="img"
						sx={{
							width: { xs: "100px", md: "161px" },
							height: { xs: "100px", md: "161px" },
							objectFit: "contain",
							filter: props.myAccount
								? "blur(0px)"
								: state.user.get() !== "" &&
								  state.plan.get() !== "" &&
								  state.plan.get() !== undefined &&
								  state.plan.get() !== null
								? "blur(0px)"
								: "blur(8px)",
						}}
						image={props.data && props.data.image}
						alt="product image"
					/>
				</Box>
				<Box
					sx={
						{
							// display: "flex",
							// flexDirection: "row-reverse",
						}
					}
				></Box>
			</Card>
			{snackBarProps.openSnack && (
				<Snackbars
					{...snackBarProps}
					onClose={() =>
						setSnackBarProps({ ...snackBarProps, openSnack: false })
					}
				></Snackbars>
			)}
		</Box>
	);
}
